import { IonBadge, IonButton, IonButtons, IonCard, IonCardContent, IonChip, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonImg, IonItem, IonLabel, IonMenuButton, IonNote, IonPage, IonRefresher, IonRefresherContent, IonRow, IonSkeletonText, IonItemOption, IonItemOptions, IonItemSliding, IonText, IonTitle, IonToolbar, RefresherEventDetail, useIonAlert, useIonLoading, useIonRouter, useIonToast, useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react';
import { add, addCircleOutline, alarmOutline, alertCircleOutline, at, car, caretForwardCircleOutline, checkmark, checkmarkCircle, checkmarkCircleOutline, chevronBackOutline, closeCircle, closeCircleOutline, copyOutline, ellipsisHorizontal, globeOutline, helpCircleOutline, informationCircleOutline, location, locationOutline, mapOutline, medkitOutline, navigate, notificationsOutline, paw, pencil, people, play, playOutline, shareOutline, stop, stopCircle, stopOutline, stopSharp, timerOutline, trashOutline, walk, walkOutline } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import { useAppContext } from '../AppProvider';
import { Link, useParams } from 'react-router-dom';
import LocationButton from "../components/LocationButton";
import TimerProgressBar from '../components/TimerProgressBar';
import { useCountdownTimer } from '../components/CountdownTimer';
import { Geolocation } from '@capacitor/geolocation';
import { Preferences } from '@capacitor/preferences';
import { useDeviceContext } from '../components/useDeviceContext';


interface RouteParams {
    token: string;
}

const TimerView: React.FC = () => {
    const [present, dismiss] = useIonLoading();
        
    const [loading, setLoading] = useState<boolean>(true);
    const [timer, setTimer] = useState<any>({});
    const [timerStatus, setTimerStatus] = useState<string>('');
    const [typeSetting, setTypeSetting] = useState<string>('');
    const [placeName, setPlaceName] = useState<any>({});
    const [placeToken, setPlaceToken] = useState<string>('');
    const [routeName, setRouteName] = useState<string>('');
    const [routeToken, setRouteToken] = useState<string>('');
    const [routeType, setRouteType] = useState<string>('');
    const [activity, setActivity] = useState<string>('');
    const [timerName, setTimerName] = useState<string>('');
    const [startTime, setStartTime] = useState<number>(0);
    const [endTime, setEndTime] = useState<number>(0);
    const [timerTimezone, setTimerTimezone] = useState<string>('');
    const [todayIsDST, setTodayIsDST] = useState<boolean>(false); 
    const [timerDST, setTimerDST] = useState<boolean>(false);
    const [alarmDelay, setAlarmDelay] = useState<any>();  

    const [valStartDateTime, setValStartDateTime] = useState<string>('');
    const [valEndDateTime, setValEndDateTime] = useState<string>('');

    const [partySize, setPartySize] = useState<string>('1');
    const [selectedPartnerTokens, setSelectedPartnerTokens] = useState<any[]>([]);
    const [selectedPartnerEmails, setSelectedPartnerEmails] = useState<any[]>([]);
    const [selectedPartnerNames, setSelectedPartnerNames] = useState<any[]>([]);
    const [selectedKids, setSelectedKids] = useState<any[]>([]);
    const [selectedKidNames, setSelectedKidNames] = useState<any[]>([]);
    const [selectedPets, setSelectedPets] = useState<any[]>([]);
    const [selectedPetNames, setSelectedPetNames] = useState<any[]>([]);
    const [selectedVehicleStartTokens, setSelectedVehicleStartTokens] = useState<any[]>([]);
    const [selectedVehicleStartNames, setSelectedVehicleStartNames] = useState<any[]>([]);
    const [selectedVehicleEnrouteTokens, setSelectedVehicleEnrouteTokens] = useState<any[]>([]);
    const [selectedVehicleEnrouteNames, setSelectedVehicleEnrouteNames] = useState<any[]>([]);
    const [selectedVehicleEndTokens, setSelectedVehicleEndTokens] = useState<any[]>([]);
    const [selectedVehicleEndNames, setSelectedVehicleEndNames] = useState<any[]>([]);
    const [equipment, setEquipment] = useState<any[]>([]); 
    const [checkedEquipment, setCheckedEquipment] = useState<any[]>([]); 
    const [selectedContacts, setSelectedContacts] = useState<string[]>([]);
    const [selectedContactEmails, setSelectedContactEmails] = useState<string[]>([]);
    const [selectedContactNames, setSelectedContactNames] = useState<string[]>([]);

    const [cachedBreadcrumbs, setCachedBreadcrumbs] = useState<number>(0);
    const [isAutoTracking, setIsAutoTracking] = useState<boolean>(false); 
    
    const [showCheckInButton, setShowCheckInButton] = useState(true);
    const [isSharingSummary, setIsSharingSummary] = useState<boolean>(false); 
    const [isSharingMap, setIsSharingMap] = useState<boolean>(false);
    const [isAddingTime, setIsAddingTime] = useState<boolean>(false); 
    const [isCheckingIn, setIsCheckingIn] = useState<boolean>(false);
    const [isCopying, setIsCopying] = useState<boolean>(false);
    const [isDeleting, setIsDeleting] = useState<boolean>(false);
    const [isOpen, setIsOpen] = useState(false);

    const { networkStatus, setNetworkStatus, getAppStatus, authKey, authenticateMember, accountSetupPct, alarms, setShowLoader, level, limits, locationPerm, locationPermStr, profiles, settings, setCurrentTimers, SWFullHorizLogo, SWTextDarkLogo, textLogoLoaded, fadeInTextLogo, getCurrentTimers, currentTimerStatus, setCurrentTimer, setCurrentTimerEnd, setCurrentTimerStatus, timezones, getTimezones, getTimezonesIANA, timezoneName, timezoneIANAName, nl2br } = useAppContext();
        
    const [showAlert] = useIonAlert();
    const [showToast] = useIonToast();
    const savePosBtnRef = useRef<any>();
    const autoTrackingRef = useRef<NodeJS.Timeout | null>(null);
    const stopTrackingBtnRef = useRef<any>();

    const { token } = useParams<RouteParams>();
    const router = useIonRouter();
    const { updateCountdownEnd, startCountdown, stopCountdown } = useCountdownTimer();
    const deviceCtx = useDeviceContext();

    //
    // Authenticate Member
    //
    useIonViewWillEnter(() => { 
        setShowLoader(true);
        const authenticate = async () => {
            setLoading(true);

            const appstat = await getAppStatus();
            
            if (!networkStatus && appstat === 'No') {
                dismiss();
                router.push('/connection', 'forward');
            } else {
                const authenticated = await authenticateMember();               
                if(!authenticated || authenticated.mt == '') {
                    dismiss();
                    router.push('/login', 'forward');
                } else {      
                    setTodayIsDST(checkDST());
                    await getTimezonesIANA();
                    await getTimer(token);

                    const existing = await Preferences.get({ key: 'cachedBreadcrumbs' });
                    const list = existing.value ? JSON.parse(existing.value) : [];
                    setCachedBreadcrumbs(list.length);
                     
                    setLoading(false);
                    setShowLoader(false);
                }
            }
        };
        
        authenticate();
    }); 


    useEffect(() => {
        if (networkStatus) {
            saveCachedBreadcrumbs();
        }
    }, [networkStatus]);


    const getTimer = async (tt: string) => {
        try {
            const formData = new FormData();
            formData.append('mt', authKey.mt);
            formData.append('tt', tt);
            const response = await fetch('https://api.besolowise.com/timers/get/', {
                method: 'post',
                credentials: 'include',
                body: formData
            });
            
            if(response.ok) {
                const obj = await response.json();
                //console.log(obj);
                if(typeof obj.id === 'number') {                    
                    setTimerName(obj.name);
                    setTimerStatus(obj.status);
                    setTypeSetting(obj.placeToken ? 'STATIONARY' : 'MOBILE');
                    setPlaceName(obj.startPlace);
                    setPlaceToken(obj.startPlaceToken);
                    setRouteName(obj.routeName);
                    setRouteToken(obj.routeToken);
                    setRouteType(obj.routeType);
                    setActivity(obj.activity);
                    setValStartDateTime(obj.startTimeStr);
                    setValEndDateTime(obj.endTimeStr);
                    setStartTime(obj.startTimeISO);
                    setEndTime(obj.endTimeISO);
                    setTimerTimezone(obj.ianaTimezone);
                    setTimerDST(obj.endDST === '0' ? false : true);
                    setAlarmDelay(obj.delay);
                    setPartySize(obj.partySize.toString());
                    setSelectedPartnerTokens(obj.partnerTokens);
                    setSelectedPartnerEmails(obj.partnerEmails);
                    setSelectedPartnerNames(obj.partnerNames);
                    setSelectedContacts(obj.contactTokens);
                    setSelectedContactEmails(obj.contactEmails);
                    setSelectedContactNames(obj.contactNames);
                    setSelectedKids(obj.kidTokens);
                    setSelectedKidNames(obj.kidNames);
                    setSelectedPets(obj.petTokens);
                    setSelectedPetNames(obj.petNames);
                    setSelectedVehicleStartTokens(obj.vehicleStartTokens);
                    setSelectedVehicleStartNames(obj.vehicleStartNames);
                    setSelectedVehicleEnrouteTokens(obj.vehicleEnrouteTokens);
                    setSelectedVehicleEnrouteNames(obj.vehicleEnrouteNames);
                    setSelectedVehicleEndTokens(obj.vehicleEndTokens);
                    setSelectedVehicleEndNames(obj.vehicleEndNames);
                    setCheckedEquipment(obj.equipmentNames);
                    setTimer(obj);
                    if (obj.status == '1') {
                        setCurrentTimer(obj);
                        setCurrentTimerEnd(new Date(obj.endTimeISO).getTime());
                        setCurrentTimerStatus('1');
                    }

                } else {
                    showToast({
                        message: 'Data Error',
                        duration: 2000,
                        color: 'danger',
                        position: 'bottom'
                    });
                }
            } else {
                showToast({
                    message: 'Response Error',
                    duration: 2000,
                    color: 'danger',
                    position: 'bottom'
                });
            }
        } catch(error) {
            // Removed the following b/c it was triggered pre-maturely / unnecessarily / too often
            /*showToast({
                message: 'Connection: ' + error,
                duration: 2000,
                color: 'danger',
                position: 'bottom'
            });*/
        }       
    };

    const checkDST = () => {
        const now = new Date();
        const januaryOffset = new Date(now.getFullYear(), 0, 1).getTimezoneOffset();
        const julyOffset = new Date(now.getFullYear(), 6, 1).getTimezoneOffset();    
        return now.getTimezoneOffset() !== januaryOffset;
    };
    

    //
    // Check-in to Timer
    //
    const confirmCheckInTimer = async () => {
        showAlert({
            header: 'Confirm!',
            message: 'Are you sure you want to CHECK IN?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'alert-button-cancel', 
                },
                {
                    text: 'Check In',
                    role: 'confirm',
                    cssClass: 'alert-button-confirm',
                    handler: () => { checkInTimer() },
                }
            ]
        })
    };


    const checkInTimer = async () => {    
        setIsCheckingIn(true);
        await present('Checking in...');
        try {
            const formData = new FormData();
            formData.append('mt', authKey.mt);
            formData.append('token', token);
            const apiURI = 'https://api.besolowise.com/timers/check-in/';
            const response = await fetch(apiURI, {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if(response.ok) {
                const obj = await response.json(); 
                if(obj.success) {
                    stopCountdown();
                    await getTimer(token);
                    await getCurrentTimers(authKey.mt);
                    //setCurrentTimerStatus('2')
                    //setCurrentTimers([]);
                    //timer.status = '2';
                    //setTimerStatus('2');
                } else {
                    showToast({
                        message: 'Data error.',
                        duration: 2000,
                        color: 'danger',
                    });
                }
            } else {
                showToast({
                    message: 'Response error. Try again',
                    duration: 2000,
                    color: 'danger',
                });
            }
        } catch(error) {
            showToast({
                message: 'No Connection. Try again',
                duration: 2000,
                color: 'danger',
            });
        }   
        setIsCheckingIn(false);   
        dismiss();            
    };


    //
    // Add Time to Timer
    //
    const confirmAddTime = async (period:any) => {
        showAlert({
            header: 'Confirm!',
            message: 'Are you sure you want to extend this Timer by ' + period + ' minutes?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'alert-button-cancel', 
                },
                {
                    text: 'Add ' + period + ' mins',
                    role: 'confirm',
                    cssClass: 'alert-button-confirm',
                    handler: () => { addTime(period) },
                }
            ]
        })
    };

    const addTime = async (period:any) => {
        setIsAddingTime(true);
        await present('Adding ' + period + ' mins...');       
                   
        try {
            const formData = new FormData();
            formData.append('mt', authKey.mt);
            formData.append('token', token);
            formData.append('period', period);
            const apiURI = 'https://api.besolowise.com/timers/extend/';
            const response = await fetch(apiURI, {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if(response.ok) {
                const obj = await response.json(); 
                if(obj.success) {
                    await getTimer(token);
                    await getCurrentTimers(authKey.token);
                    showToast({
                        message: period + ' minutes were added',
                        duration: 2000,
                        color: 'success',
                    });
                } else {
                    showToast({
                        message: 'Data error.',
                        duration: 2000,
                        color: 'danger',
                    });
                }
            } else {
                showToast({
                    message: 'Response error.',
                    duration: 2000,
                    color: 'danger',
                });
            }
        } catch(error) {
            showToast({
                message: 'Connection Error',
                duration: 2000,
                color: 'danger',
            });
        }  
        setIsAddingTime(false);   
        dismiss(); 
    };


    //
    // Copy Timer
    //
    const confirmCopyTimer = async () => {
        showAlert({
            header: 'Confirm!',
            message: 'This will make a copy with the same time, next day.',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'alert-button-cancel', 
                },
                {
                    text: 'OK',
                    role: 'confirm',
                    cssClass: 'alert-button-confirm',
                    handler: () => { copyTimer() },
                }
            ]
        })
    };

    const copyTimer = async () => {
        setIsCopying(true);
        await present('Copying ...');
        try {
            const formData = new FormData();
            formData.append('mt', authKey.mt);
            formData.append('token', token);
            const apiURI = 'https://api.besolowise.com/timers/copy/';
            const response = await fetch(apiURI, {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if(response.ok) {
                const obj = await response.json(); 
                //console.log(obj);
                if(obj.success) {
                    router.push('/account/timers/', 'back');
                } else {
                    showToast({
                        message: 'Data error.',
                        duration: 2000,
                        color: 'danger',
                    });
                }
            } else {
                showToast({
                    message: 'Response error.',
                    duration: 2000,
                    color: 'danger',
                });
            }
        } catch(error) {
            showToast({
                message: 'Connection Error: ' + error,
                duration: 2000,
                color: 'danger',
            });
        }  
        setIsCopying(false);   
        dismiss(); 
    };
   

    //
    // Delete Timer
    //
    const confirmDeleteTimer = async () => {
        showAlert({
            header: 'Confirm!',
            message: 'Are you sure you want to REMOVE this Timer?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'alert-button-cancel', 
                },
                {
                    text: 'REMOVE',
                    role: 'confirm',
                    cssClass: 'alert-button-confirm',
                    handler: () => { deleteTimer() },
                }
            ]
        })
    };

    const deleteTimer = async () => {
        setIsDeleting(true);
        await present('Removing ...');
        try {
            const formData = new FormData();
            formData.append('mt', authKey.mt);
            formData.append('token', token);
            const apiURI = 'https://api.besolowise.com/timers/delete/';
            const response = await fetch(apiURI, {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if(response.ok) {
                const obj = await response.json(); 
                //console.log(obj);
                if(obj.success) {
                    router.push('/account/timers', 'back');
                } else {
                    showToast({
                        message: obj.message,
                        duration: 2000,
                        color: 'danger',
                    });
                }
            } else {
                showToast({
                    message: 'Response error.',
                    duration: 2000,
                    color: 'danger',
                });
            }
        } catch(error) {
            showToast({
                message: 'Connection Error: ' + error,
                duration: 2000,
                color: 'danger',
            });
        } 
        setIsDeleting(false);
        dismiss();
    };

    
    //
    // Share Timer Summary
    //
    const confirmShareSummary = async () => {
        showAlert({
            header: 'Confirm!',
            message: 'Are you sure you want to SHARE your planned check-in time and location with your contacts?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'alert-button-cancel', 
                },
                {
                    text: 'OK',
                    role: 'confirm',
                    cssClass: 'alert-button-confirm',
                    handler: () => { shareSummary() },
                }
            ]
        })
    };

    const shareSummary = async () => {
        setIsSharingSummary(true);
        await present('Sharing summary ...');
        try {
            const formData = new FormData();
            formData.append('mt', authKey.mt);
            formData.append('token', token);
            const apiURI = 'https://api.besolowise.com/timers/share/summary/';
            const response = await fetch(apiURI, {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if(response.ok) {
                const obj = await response.json(); 
                if(obj.success) {
                    showToast({
                        message: 'Your Timer summary was shared.',
                        duration: 2000,
                        color: 'success',
                    });
                } else {
                    showToast({
                        message: 'Data error.',
                        duration: 2000,
                        color: 'danger',
                    });
                }
            } else {
                showToast({
                    message: 'Response error.',
                    duration: 2000,
                    color: 'danger',
                });
            }
        } catch(error) {
            showToast({
                message: 'Connection Error: ' + error,
                duration: 2000,
                color: 'danger',
            });
        } 
        setIsSharingSummary(false);
        dismiss();
    };


    //
    // Share Live Map
    //
    const confirmShareMap = async () => {
        showAlert({
            header: 'Confirm!',
            message: 'Are you sure you want to SHARE a live map of your location with your contacts?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'alert-button-cancel', 
                },
                {
                    text: 'OK',
                    role: 'confirm',
                    cssClass: 'alert-button-confirm',
                    handler: () => { shareMap() },
                }
            ]
        })
    };

    const shareMap = async () => {
        setIsSharingMap(true);
        await present('Sharing map ...');
        try {
            const formData = new FormData();
            formData.append('mt', authKey.mt);
            formData.append('token', token);
            const apiURI = 'https://api.besolowise.com/timers/share/';
            const response = await fetch(apiURI, {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if(response.ok) {
                const obj = await response.json(); 
                if(obj.success) {
                    showToast({
                        message: 'Your map was shared.',
                        duration: 2000,
                        color: 'success',
                    });
                } else {
                    showToast({
                        message: 'Data error.',
                        duration: 2000,
                        color: 'danger',
                    });
                }
            } else {
                showToast({
                    message: 'Response error.',
                    duration: 2000,
                    color: 'danger',
                });
            }
        } catch(error) {
            showToast({
                message: 'Connection Error: ' + error,
                duration: 2000,
                color: 'danger',
            });
        }  
        setIsSharingMap(false);
        dismiss();
    };


    const typeText = (s: string) => {
        switch(s) {
            case 'ONE-WAY': return 'One-way'
            case 'LOOP': return 'Loop'       
            default:  return 'Unknown'
        }
    };

    const categoryText = (s: string) => {
        switch(s) {
            case '1': return 'Air'
            case '2': return 'Road'
            case '3': return 'Trail'
            case '4': return 'Water'           
            default:  return 'Unknown'
        }
    };
    
    const statusChip = (s: string) => {
        switch(s) {
            case '0': return <IonChip slot='end' color={'medium'}><IonIcon icon={timerOutline} className='ion-margin-end'></IonIcon> In-Future </IonChip>
            case '1': return <IonChip slot='end' color={'secondary'}><IonIcon icon={caretForwardCircleOutline} className='ion-margin-end'></IonIcon> Active </IonChip>
            case '2': return <IonChip slot='end' color={'success'}><IonIcon icon={checkmarkCircleOutline} className='ion-margin-end'></IonIcon> You are Checked-In </IonChip>
            case '3': return <IonChip slot='end' color={'warning'}><IonIcon icon={alarmOutline} className='ion-margin-end'></IonIcon> Over-Due </IonChip>
            case '4': return <IonChip slot='end' color={'danger'}><IonIcon icon={alertCircleOutline} className='ion-margin-end'></IonIcon> ALERT </IonChip>           
            default:  return <IonChip slot='end' color={'medium'}><IonIcon icon={helpCircleOutline} className='ion-margin-end'></IonIcon> Unknown </IonChip>
        }
    };

    const alarmDelayText = (s: string) => {
        switch(s) {
            case '0.00': return 'No Delay'
            case '0.25': return '15 minutes'
            case '0.50': return '30 minutes'
            case '1': return '1 hour'
            case '2': return '2 hours'
            case '3': return '3 hours'
            case '6': return '6 hours'
            case '12': return '12 hours'
            case '24': return '24 hours'
            default:  return 'Unknown'
        }
    };

    const partySizeText = (s: string) => {
        switch(s) {
            case '0': return 'No one, I\'m solo.'
            default:  return s + ' other ' + (s == '1' ? 'person is' : 'people are') + ' with me.'
        } 
    };

    
    //
    // Get Current Position
    //
    const getCurrentPosition = async () => {
        try {
            let pos1 = await Geolocation.getCurrentPosition({
                enableHighAccuracy: true,
                timeout: 7000,
                maximumAge: 0
            });

            // wait briefly for GPS stabilization
            await new Promise(resolve => setTimeout(resolve, 2000));

            let pos2 = await Geolocation.getCurrentPosition({
                enableHighAccuracy: true,
                timeout: 7000,
                maximumAge: 0
            });

            return (pos2.coords.accuracy < pos1.coords.accuracy)
                ? pos2.coords
                : pos1.coords;
        } catch (e) {
            return false;
        }
    };


    //
    // Save Position
    //
    const savePosition = async () => {
        //if (savePosBtnRef.current) savePosBtnRef.current.disabled = true;
        //const btnText: any = document.getElementById('breadcrumb-btn-text');
        //if (btnText) btnText.innerHTML = 'Dropping ...';

        let nowTime = new Date().getTime();
            nowTime = Math.round(nowTime / 1000);
        const timeoutMs = 20000;
        const controller = new AbortController();
        const id = setTimeout(() => controller.abort(), timeoutMs);
        
        let latitude = 0;            
        let longitude = 0; 
        let accuracy = 0; 
        let coords = '';

        //if (locationPerm) {
            let Coordinates = await getCurrentPosition();
            //console.log(Coordinates);
            
            if(Coordinates !== false && Coordinates.latitude !== undefined && Coordinates.longitude !== undefined) {
                latitude = Coordinates.latitude;
                longitude = Coordinates.longitude;
                accuracy = Coordinates.accuracy;
                coords = latitude + ',' + longitude + ',' + accuracy;
            }
        //}
        
        const formData = new FormData();
        formData.append('mt', authKey.mt);
        formData.append('lat', latitude.toString());
        formData.append('lon', longitude.toString());
        formData.append('acc', accuracy.toString());   
        
        const breadcrumb = [nowTime, authKey.mt, latitude.toString(), longitude.toString(), accuracy.toString()];

        try {
            
            const response = await fetch('https://api.besolowise.com/tracks/insert/', {
                method: 'POST',
                credentials: 'include',
                body: formData,
                signal: controller.signal,
            });

            if(response.ok) {
                const obj = await response.json(); 
                
                if(obj.success) {
                    //if (btnText) savePosBtnRef.current.color = 'success';
                    //if (btnText) btnText.innerHTML = 'LOCATION SAVED';
                    //if (savePosBtnRef.current) savePosBtnRef.current.disabled = false;
                    
                    // 
                    // Try sending cached breadcrumbs
                    //
                    
                    if (cachedBreadcrumbs > 0) await saveCachedBreadcrumbs();

                    showToast({
                        message: 'Your location was saved.',
                        duration: 5000,
                        color: 'success',
                        position: 'bottom'
                    });

                } else {
                    //if (savePosBtnRef.current) savePosBtnRef.current.color = 'danger';
                    //if (savePosBtnRef.current) savePosBtnRef.current.disabled = false;
                    
                    showToast({
                        message: 'Error: ' + obj.message,
                        duration: 3000,
                        color: 'danger',
                    });
                } 

                /*setTimeout(() => {
                    if (savePosBtnRef.current) savePosBtnRef.current.color = 'tertiary';
                    if (btnText) btnText.innerHTML = 'Drop a Breadcrumb';
                }, 7000);*/
                
            } else {
                //throw new Error(`Server responded with ${response.status}`);

                /*if (savePosBtnRef.current) savePosBtnRef.current.color = 'danger';
                if (savePosBtnRef.current) savePosBtnRef.current.disabled = false;
                setTimeout(() => {
                    //savePosBtnRef.current.color = 'tertiary';
                    if (btnText) btnText.innerHTML = 'Drop a Breadcrumb';
                }, 2500);*/

                showToast({
                    message: 'Response Error',
                    duration: 2000,
                    color: 'danger',
                });
            } 

        } catch(error) {
            console.log(error);
            //clearTimeout(id);
            await cacheBreadcrumb(breadcrumb); 
        }               
    };


    //
    // Locally cache Breadcrumb
    //
    const cacheBreadcrumb = async (breadcrumb:any) => {
        //setNetworkStatus(false);
        
        //const btnText: any = document.getElementById('breadcrumb-btn-text');
        //if (savePosBtnRef.current) savePosBtnRef.current.color = 'danger';
        //if (btnText) btnText.innerHTML = 'No connection';

        console.log('Caching breadcrumb...');

        const existing = await Preferences.get({ key: 'cachedBreadcrumbs' });
        const list = existing.value ? JSON.parse(existing.value) : [];

        list.push(breadcrumb);

        await Preferences.set({
            key: 'cachedBreadcrumbs',
            value: JSON.stringify(list),
        });       

        setTimeout(() => {
            //if (btnText) btnText.innerHTML = 'Drop a Breadcrumb';
            //savePosBtnRef.current.color = 'tertiary';
            if (savePosBtnRef.current) savePosBtnRef.current.disabled = false; 
            //setCachedBreadcrumbs(list.length);
        }, 1500);
    };


    //
    // Save cached Breadcrumbs
    //
    const saveCachedBreadcrumbs = async () => {
        let nowTime = new Date().getTime();
            nowTime = Math.round(nowTime / 1000);
        const timeoutMs = 3000;
        const controller = new AbortController();
        const id = setTimeout(() => controller.abort(), timeoutMs);

        const existing = await Preferences.get({ key: 'cachedBreadcrumbs' });
        
        if (cachedBreadcrumbs > 0) {
            const list: any = existing.value ? JSON.parse(existing.value) : [];

            const formDataBatch = new FormData();
            formDataBatch.append('mt', authKey.mt);
            formDataBatch.append('tracks', JSON.stringify(list));
            
            try {
                const response = await fetch('https://api.besolowise.com/tracks/insert-batch/', {
                    method: 'POST',
                    credentials: 'include',
                    body: formDataBatch,
                    signal: controller.signal,
                });

                if(response.ok) {
                    const obj = await response.json(); 
                    
                    if(obj.success) {
                        console.log('All cached breadcrumbs were dropped.');
                        await Preferences.remove({ key: 'cachedBreadcrumbs' });
                        setCachedBreadcrumbs(0);
                    } else {
                        console.log('Connection Error.');
                    }
                } else {
                    console.log('No Connection');
                }
            } catch(error) {
                clearTimeout(id);
                console.log('Could not save cached Breadcrumbs (' + error + ')');
            }
        }
    };


    const startAutoTracking = async () => {
        setIsAutoTracking(true);
        //stopTrackingBtnRef.current.color = 'danger';
        await savePosition();
        let refreshTime = 1 * 60000; // 60 seconds            
        autoTrackingRef.current = setTimeout(() => startAutoTracking(), refreshTime); 
    };

    const stopAutoTracking = async () => {
        setIsAutoTracking(false);
        if(autoTrackingRef.current !== null) {
            clearTimeout(autoTrackingRef.current);
            autoTrackingRef.current = null;
        }  
    };

    
    const closeThisSliding = async (ev: React.MouseEvent) => {
        const sliding = (ev.currentTarget as HTMLElement).closest('ion-item-sliding') as HTMLIonItemSlidingElement | null;
        await sliding?.close(); 
    };
    

    const editTimer = (tt: string) => {
        router.push('/account/timer/edit/'+tt, 'forward');
    };


    const handleRefresh = (event: CustomEvent<RefresherEventDetail>) => {
        stopCountdown();
        setTimeout(async () => {
          await getTimer(token);
          await getCurrentTimers(authKey.token);
          event.detail.complete();
        }, 2000);
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar className='ion-text-center'>
                    <IonButtons slot='start'>
                        <IonButton color={'tertiary'} routerDirection='back' routerLink='/account/timers'>Timers</IonButton>
                    </IonButtons>
                    <IonTitle><IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg" id='TimerView'>

                <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>

                <IonGrid>
                    <IonRow>
                        <IonCol size='12' sizeSm='7' sizeLg='8'>
                            <h1><IonIcon className='m-hide' color={'secondary'} icon={alarmOutline}></IonIcon> {timer.name}<br /><span>One-time Timer</span></h1>                            
                        </IonCol>
                        <IonCol className='ion-margin-bottom top-action-button'  size='12' sizeSm='5' sizeLg='4'>                            
                            {!loading && (timer.status == '0' || timer.status == '2') &&
                                <>
                                    { alarms < limits.timers &&
                                    <IonButton className='ion-margin' color={'secondary'} fill="solid" onClick={confirmCopyTimer}><IonIcon icon={copyOutline} slot='start'></IonIcon> Copy Timer</IonButton>
                                    }
                                </>
                            }  
                        </IonCol>
                    </IonRow>
                </IonGrid>

                <div className='ion-padding-bottom'>
                    {!loading &&
                        <>
                        {showCheckInButton && timer.status !== undefined  && timer.status != '0' && timer.status != '2' &&
                            <>
                                {deviceCtx.useSlideAction 
                                    ? <div className='ion-text-center'>
                                        <IonItemSliding style={{'margin': '20px auto 10px', 'width': '320px'}}>
                                            <IonItem className='cursor-pointer' color={'secondary'}>
                                                <IonLabel className='ion-text-center'>
                                                    <IonIcon icon={chevronBackOutline} style={{verticalAlign: 'sub'}}></IonIcon>                                  
                                                    Slide for Check-In
                                                </IonLabel>
                                            </IonItem>
                                            <IonItemOptions>
                                                <IonItemOption 
                                                    color="success" 
                                                    expandable
                                                    onClick={async (e) => {
                                                        confirmCheckInTimer();
                                                    }}
                                                >
                                                    <IonIcon icon={checkmarkCircleOutline} slot='start'></IonIcon> 
                                                    Check In Now
                                                </IonItemOption>
                                            </IonItemOptions>
                                        </IonItemSliding>
                                        <IonNote>
                                            First slide left, then tap "Check In Now"
                                        </IonNote>
                                      </div>
                                    : <p className='ion-text-center'>
                                        <IonButton className='ion-margin' color={'secondary'} onClick={confirmCheckInTimer} size='large'><IonIcon icon={checkmarkCircleOutline} slot='start'></IonIcon> Check In Now</IonButton>
                                      </p>
                                }

                                <p className='ion-text-center'>
                                    <IonButton className='ion-margin' color={'tertiary'} fill='outline' onClick={() => confirmAddTime('15')} size='small'><IonIcon icon={add} slot='start'></IonIcon> Add 15 mins</IonButton>

                                    <IonButton className='ion-margin' color={'tertiary'} fill='outline' onClick={() => confirmAddTime('30')} size='small'><IonIcon icon={add} slot='start'></IonIcon> Add 30 mins</IonButton>

                                    <IonButton className='ion-margin' color={'tertiary'} fill='outline' onClick={() => confirmAddTime('60')} size='small'><IonIcon icon={add} slot='start'></IonIcon> Add 60 mins</IonButton>
                                </p>

                                {locationPermStr == 'Granted' &&
                                <>
                                    <div className='ion-text-center'>
                                        {!isAutoTracking
                                            ? <>
                                                <LocationButton
                                                    onDrop={async () => {
                                                        await savePosition();
                                                    }}
                                                />

                                                {cachedBreadcrumbs >= 1 &&
                                                    <IonBadge color="danger" slot='end'>{cachedBreadcrumbs}</IonBadge>
                                                }
                                                
                                                {/*<IonButton 
                                                    className='ion-margin' 
                                                    color={'success'} 
                                                    onClick={startAutoTracking} 
                                                    size='small'>
                                                        <IonIcon icon={playOutline} slot='start'></IonIcon> 
                                                        <span>Start Auto-Tracking</span>    
                                                </IonButton>*/}
                                              </>
                                            : <>
                                                {/*<IonButton 
                                                    className='ion-margin-top' 
                                                    color={'danger'} 
                                                    onClick={stopAutoTracking} 
                                                    ref={stopTrackingBtnRef}
                                                    size='small'>
                                                        <IonIcon icon={stopCircle} slot='start'></IonIcon> 
                                                        Stop Auto-Tracking    
                                                </IonButton>*/}
                                              </>
                                        }
                                    </div>
                                </>
                                }
                            </>
                        }                         
                        </>
                    }                 
                </div>
                
                <IonCard
                    {...((timer.status != '2')
                        && { routerDirection: 'forward', routerLink: `/account/timer/edit/${token}#when` }
                        )}
                    >
                    <IonCardContent>                        
                            <IonGrid>
                                <IonRow>
                                    <IonCol size='12'>
                                        <IonText color={'tertiary'}><h2>When?</h2></IonText>
                                    </IonCol>
                                </IonRow>   

                                <IonRow>
                                    <IonCol size='12'>
                                        <IonItem lines='none'>
                                            <IonIcon color={'tertiary'} icon={play} slot='start'></IonIcon>                                    
                                            <IonLabel>                                                    
                                                {loading 
                                                    ? (<IonSkeletonText animated={true} style={{ width: '45%' }}></IonSkeletonText>)
                                                    : (<b>{valStartDateTime}</b>)
                                                }
                                            </IonLabel>
                                        </IonItem>
                                    </IonCol>                          
                                </IonRow>

                                <IonRow>
                                    <IonCol size='12'>                                        
                                        <IonItem lines='none'>
                                            <IonIcon color={'tertiary'} icon={stop} slot='start'></IonIcon>   
                                            <IonLabel>                                  
                                                {loading 
                                                    ? <IonSkeletonText animated={true} style={{ width: '45%' }}></IonSkeletonText>
                                                    : <b>{valEndDateTime}</b>
                                                }
                                            </IonLabel>
                                        </IonItem>
                                    </IonCol>                          
                                </IonRow>

                                <IonRow>
                                    <IonCol size='12'>                                        
                                        <IonItem lines='none'>
                                            <IonIcon color={'tertiary'} icon={globeOutline} slot='start'></IonIcon>   
                                            <IonLabel className='ion-text-wrap'>
                                                { loading
                                                    ? <IonSkeletonText animated={true} style={{ width: '45%' }}></IonSkeletonText>
                                                    : <><b>{timezoneIANAName(timerTimezone)} Time</b></>
                                                }
                                            </IonLabel>
                                        </IonItem>                                       
                                    </IonCol>                          
                                </IonRow>

                                <IonRow>
                                    <IonCol className='ion-padding' size='12'>
                                        <TimerProgressBar 
                                            token={token} 
                                            getTimer={getTimer} 
                                            status={timerStatus} 
                                            setTimerStatus={setTimerStatus}
                                            startTimeISO={startTime} 
                                            endTimeISO={endTime} 
                                            alarmDelay={alarmDelay}
                                            timerTimezone={timerTimezone} 
                                            todayIsDST={todayIsDST} 
                                            parent={'view'} />                                    
                                    </IonCol>
                                </IonRow>

                                <IonRow className='ion-margin-bottom'>
                                    <IonCol size='12'>
                                        <IonItem lines='none'>
                                            <IonIcon color={'tertiary'} icon={alarmOutline} slot='start'></IonIcon>                                    
                                            <IonLabel><strong>Alarm Delay:</strong> {alarmDelayText(alarmDelay)}</IonLabel>
                                        </IonItem>
                                    </IonCol>
                                </IonRow>

                                {(!loading && timer.statusCheckTime != 0) && 
                                    <IonChip className='ion-margin-start' color={'success'}><IonIcon className='ion-no-margin' icon={notificationsOutline}></IonIcon></IonChip>
                                } 
                                {(!loading && timer?.alarm != 0) && 
                                    <IonChip color={'danger'}><IonIcon className='ion-no-margin' icon={notificationsOutline}></IonIcon></IonChip>
                                }  

                            </IonGrid>                            
                    </IonCardContent>
                </IonCard>
                    
                <IonCard
                    {...((timer.status != '2')
                        && { routerDirection: 'forward', routerLink: `/account/timer/edit/${token}#where` }
                        )}
                    >
                    <IonCardContent>                        
                            <IonGrid>
                                <IonRow>
                                    <IonCol size='12'>
                                        <h2><IonText color={'tertiary'}>Where?</IonText></h2>
                                    </IonCol>                     
                                </IonRow>

                                <IonRow className='ion-margin-bottom'>
                                    { typeSetting == 'STATIONARY' &&
                                        (
                                        <IonCol size='12'>
                                            <IonItem lines='none'>
                                                <IonIcon color={'tertiary'} icon={location} slot='start'></IonIcon> 
                                                <IonLabel className='ion-text-wrap'>                                                    
                                                    {loading 
                                                        ? (<IonSkeletonText animated={true} style={{ width: '45%' }}></IonSkeletonText>)
                                                        : (<IonText color={'dark'}><b>{placeName}</b></IonText>)
                                                    }
                                                </IonLabel>
                                            </IonItem>
                                        </IonCol>
                                        )
                                    }

                                    { typeSetting == 'MOBILE' &&
                                        (
                                        <IonCol size='12'>
                                            <IonItem lines='none'>
                                                <IonIcon color={'tertiary'} icon={navigate} slot='start'></IonIcon> 
                                                <IonLabel className='ion-text-wrap'>                                                    
                                                    {loading 
                                                        ? (<IonSkeletonText animated={true} style={{ width: '45%' }}></IonSkeletonText>)
                                                        : (<b>{routeName}</b>)
                                                    }
                                                </IonLabel>
                                            </IonItem> 
                                        </IonCol>
                                        )
                                    }
                                </IonRow>
                            </IonGrid>                            
                    </IonCardContent>
                </IonCard>

                <IonCard
                    {...((timer.status != '2')
                        && { routerDirection: 'forward', routerLink: `/account/timer/edit/${token}#who` }
                        )}
                    >
                    <IonCardContent>                        
                            <IonGrid>
                                <IonRow>
                                    <IonCol size='12'>
                                        <IonText color={'tertiary'}><h2>Who?</h2></IonText>  
                                    </IonCol>
                                </IonRow>   

                                <IonRow>
                                    <IonCol size='12'>
                                        <IonItem lines='none'>
                                            <IonIcon color={'tertiary'} icon={at} slot='start'></IonIcon>
                                            <IonLabel><b>SoloWise Contacts</b></IonLabel>
                                        </IonItem>
                                    </IonCol>
                                    <IonCol className='ion-padding-start' size='12'> 
                                        <IonRow>
                                            {selectedContactNames.length > 0
                                                ? (selectedContactNames.map((contact, index) => (
                                                    <IonCol key={index} sizeXs='12' sizeSm='12' sizeMd='6'>
                                                        <IonItem className='ion-margin-start' lines='none'>
                                                            <IonIcon className='ion-margin-start' color={'success'} icon={checkmarkCircle} size='small' slot='start'></IonIcon> 
                                                            <IonLabel><p>{contact}<br />{selectedContactEmails[index]}</p></IonLabel>
                                                        </IonItem>
                                                    </IonCol>)))
                                                : (<IonCol>
                                                        <IonItem className='ion-margin-start' lines='none'>
                                                            <IonIcon className='ion-margin-start' color={'warning'} icon={closeCircle} size='small' slot='start'></IonIcon>
                                                            <IonLabel><p>No Contacts selected</p></IonLabel>
                                                        </IonItem>
                                                    </IonCol>)                                            
                                            } 
                                        </IonRow>
                                    </IonCol>
                                </IonRow>

                                { level?.memberLevelID > 1 &&
                                  <>  
                                    <IonRow>
                                        <IonCol size='12'>
                                            <IonItem lines='none'>
                                                <IonIcon color={'tertiary'} icon={people} slot='start'></IonIcon>
                                                <IonLabel><b>Number of Others With You</b></IonLabel>
                                            </IonItem>
                                        </IonCol>
                                        <IonCol className='ion-padding-start' size='12'>    
                                            <IonRow>
                                                <IonCol>                                  
                                                    <IonItem className='ion-margin-start' lines='none'>
                                                        <IonIcon className='ion-margin-start' color={'success'} icon={checkmarkCircle} size='small' slot='start'></IonIcon>
                                                        <IonLabel><p>{partySizeText(partySize)}</p></IonLabel>
                                                    </IonItem>
                                                </IonCol>  
                                            </IonRow>
                                        </IonCol>
                                    </IonRow>   
                                    
                                    { settings.menuPartners == '1' && partySize != '0' &&
                                        <IonRow>
                                            <IonCol size='12'>
                                                <IonItem lines='none'>
                                                    <IonIcon color={'tertiary'} icon={people} slot='start'></IonIcon>
                                                    <IonLabel><b>SoloWise Partners</b></IonLabel>
                                                </IonItem>
                                            </IonCol>
                                            <IonCol className='ion-padding-start' size='12'> 
                                                <IonRow>
                                                    {selectedPartnerNames !== undefined && selectedPartnerNames.length > 0
                                                        ? (selectedPartnerNames.map((partner, index) => (
                                                            <IonCol key={index} sizeXs='12' sizeSm='6' sizeMd='4'>
                                                                <IonItem className='ion-margin-start' lines='none'>
                                                                    <IonIcon className='ion-margin-start' color={'success'} icon={checkmarkCircle} size='small' slot='start'></IonIcon> 
                                                                    <IonLabel><p>{partner}</p></IonLabel>
                                                                </IonItem>
                                                            </IonCol>)))
                                                        : ( <IonCol>
                                                                <IonItem className='ion-margin-start' lines='none'>
                                                                    <IonIcon className='ion-margin-start' color={'warning'} icon={closeCircle} size='small' slot='start'></IonIcon>
                                                                    <IonLabel><p style={{ margin: '0' }}>No Partners selected</p></IonLabel>
                                                                </IonItem>
                                                            </IonCol>)
                                                    } 
                                                </IonRow>
                                            </IonCol>
                                        </IonRow>
                                    }

                                    { settings.menuKids == '1' && partySize != '0' &&
                                        <IonRow>
                                            <IonCol size='12'>
                                                <IonItem lines='none'>
                                                    <IonIcon color={'tertiary'} icon={people} slot='start'></IonIcon>
                                                    <IonLabel><b>SoloWise Kids</b></IonLabel>
                                                </IonItem>
                                            </IonCol>
                                            <IonCol className='ion-padding-start' size='12'> 
                                                <IonRow>
                                                    {selectedKidNames !== undefined && selectedKidNames.length > 0
                                                        ? (selectedKidNames.map((kid, index) => (
                                                            <IonCol key={index} sizeXs='12' sizeSm='6' sizeMd='4'>
                                                                <IonItem className='ion-margin-start' lines='none'>
                                                                    <IonIcon className='ion-margin-start' color={'success'} icon={checkmarkCircle} size='small' slot='start'></IonIcon> 
                                                                    <IonLabel><p>{kid}</p></IonLabel>
                                                                </IonItem>
                                                            </IonCol>)))
                                                        : ( <IonCol>
                                                                <IonItem className='ion-margin-start' lines='none'>
                                                                    <IonIcon className='ion-margin-start' color={'warning'} icon={closeCircle} size='small' slot='start'></IonIcon>
                                                                    <IonLabel><p>No Kids selected</p></IonLabel>
                                                                </IonItem>
                                                            </IonCol>)
                                                    } 
                                                </IonRow>
                                            </IonCol>
                                        </IonRow>
                                    }

                                    { partySize != '0' &&
                                        (<IonRow>
                                            <IonCol size='12'>
                                                <IonItem lines='none'>
                                                    <IonIcon color={'tertiary'} icon={people} slot='start'></IonIcon>
                                                    <IonLabel><b>Unregistered Partners</b></IonLabel>
                                                </IonItem>
                                            </IonCol>
                                            <IonCol className='ion-padding-start' size='12'> 
                                                <IonRow>
                                                    {timer.partnerText != '' 
                                                        ? (<IonCol>
                                                                <IonItem className='ion-margin-start' lines='none'>
                                                                    <IonIcon className='ion-margin-start' color={'success'} icon={checkmarkCircle} size='small' slot='start' style={{verticalAlign: 'top'}}></IonIcon>
                                                                    <IonLabel><p><IonText><span dangerouslySetInnerHTML={{ __html: nl2br(timer.partnerText) }} /></IonText></p></IonLabel>
                                                                </IonItem>
                                                            </IonCol>)
                                                        : (<IonCol>
                                                                <IonItem className='ion-margin-start' lines='none'>
                                                                    <IonIcon className='ion-margin-start' color={'warning'} icon={closeCircle} size='small' slot='start'></IonIcon>
                                                                    <IonLabel><p>Not Recorded</p></IonLabel>
                                                                </IonItem>
                                                            </IonCol>)   
                                                    } 
                                                </IonRow>
                                            </IonCol>
                                        </IonRow>)
                                    }
                                  </>
                                }                                
                            </IonGrid>                            
                    </IonCardContent>
                </IonCard>

                <IonCard
                    {...((timer.status != '2')
                        && { routerDirection: 'forward', routerLink: `/account/timer/edit/${token}#what` }
                        )}
                    >
                    <IonCardContent>                        
                            <IonGrid>
                                <IonRow className='ion-margin-top'>
                                    <IonCol size='12'>
                                        <IonText color={'tertiary'}><h2>What?</h2></IonText>
                                    </IonCol>
                                </IonRow>

                                <IonRow>
                                    <IonCol size='12'>
                                        <IonItem lines='none'>
                                            <IonIcon color={'tertiary'} icon={walk} slot='start'></IonIcon>
                                            <IonLabel><b>Activities</b></IonLabel>
                                        </IonItem>
                                    </IonCol>
                                    <IonCol className='ion-padding-start' size='12'>
                                        <IonRow>
                                            {timer.activity != '' 
                                                ? (<IonCol>
                                                        <IonItem className='ion-margin-start' lines='none'>
                                                            <IonIcon className='ion-margin-start' color={'success'} icon={checkmarkCircle} size='small' slot='start' style={{verticalAlign: 'top'}}></IonIcon>
                                                            <IonLabel><p><IonText><span dangerouslySetInnerHTML={{ __html: nl2br(timer.activity) }} /></IonText></p></IonLabel>
                                                        </IonItem>
                                                    </IonCol>)
                                                : (<IonCol>
                                                        <IonItem className='ion-margin-start' lines='none'>
                                                            <IonIcon className='ion-margin-start' color={'warning'} icon={closeCircle} size='small' slot='start'></IonIcon>
                                                            <IonLabel><p>Not Recorded</p></IonLabel>
                                                        </IonItem>
                                                    </IonCol>)   
                                            }   
                                        </IonRow>                        
                                    </IonCol>
                                </IonRow>

                                {level?.memberLevelID > 1 && settings.menuPets == '1' &&
                                    (<IonRow>
                                        <IonCol size='12'>
                                            <IonItem lines='none'>
                                                <IonIcon color={'tertiary'} icon={paw} slot='start'></IonIcon>
                                                <IonLabel><b>SoloWise Pets</b></IonLabel>
                                            </IonItem>
                                        </IonCol>
                                        <IonCol className='ion-padding-start' size='12'> 
                                            <IonRow>
                                                {selectedPetNames.length > 0
                                                    ? (selectedPetNames.map((pet, index) => (
                                                        <IonCol key={index} sizeXs='12' sizeSm='6' sizeMd='4'>
                                                            <IonItem className='ion-margin-start' lines='none'>
                                                                <IonIcon className='ion-margin-start' color={'success'} icon={checkmarkCircle} size='small' slot='start'></IonIcon> 
                                                                <IonLabel><p>{pet}</p></IonLabel>
                                                            </IonItem>
                                                        </IonCol>)))
                                                    : (<IonCol>
                                                            <IonItem className='ion-margin-start' lines='none'>
                                                                <IonIcon className='ion-margin-start' color={'warning'} icon={closeCircle} size='small' slot='start'></IonIcon>
                                                                <IonLabel><p>No Pets selected</p></IonLabel>
                                                            </IonItem>
                                                        </IonCol>)                                            
                                                } 
                                            </IonRow>
                                        </IonCol>
                                    </IonRow>)
                                }

                                { settings?.menuVehicles == '1' && profiles?.vehicles >= 1 &&
                                    (<>
                                    
                                    <IonRow>
                                        <IonCol size='12'>
                                            <IonItem lines='none'>
                                                <IonIcon color={'tertiary'} icon={car} slot='start'></IonIcon>
                                                <IonLabel className='ion-text-wrap'><b>SoloWise Vehicles parked at { typeSetting == '' || typeSetting == 'STATIONARY' ? 'this' : 'the Starting' } Place</b></IonLabel>
                                            </IonItem>
                                        </IonCol>
                                        <IonCol className='ion-padding-start' size='12'> 
                                            <IonRow>
                                                {selectedVehicleStartNames.length > 0
                                                    ? (selectedVehicleStartNames.map((vehicle, index) => (
                                                        <IonCol key={index} sizeXs='12' sizeSm='12' sizeMd='6'>
                                                            <IonItem className='ion-margin-start' lines='none'>
                                                                <IonIcon className='ion-margin-start' color={'success'} icon={checkmarkCircle} size='small' slot='start'></IonIcon> 
                                                                <IonLabel><p>{vehicle}</p></IonLabel>
                                                            </IonItem>
                                                        </IonCol>)))
                                                    : (<IonCol>
                                                            <IonItem className='ion-margin-start' lines='none'>
                                                                <IonIcon className='ion-margin-start' color={'warning'} icon={closeCircle} size='small' slot='start'></IonIcon>
                                                                <IonLabel><p>No Vehicles selected</p></IonLabel>
                                                            </IonItem>
                                                        </IonCol>)                                            
                                                } 
                                            </IonRow>
                                        </IonCol>
                                    </IonRow>
                                    
                                    { routeType != '' &&
                                        (<IonRow>
                                            <IonCol size='12'>
                                                <IonItem lines='none'>
                                                    <IonIcon color={'tertiary'} icon={car} slot='start'></IonIcon>
                                                    <IonLabel className='ion-text-wrap'><b>SoloWise Vehicles being driven or parked somewhere along the way?</b></IonLabel>
                                                </IonItem>
                                            </IonCol>
                                            <IonCol className='ion-padding-start' size='12'> 
                                                <IonRow>
                                                    {selectedVehicleEnrouteNames.length > 0
                                                        ? (selectedVehicleEnrouteNames.map((vehicle, index) => (
                                                            <IonCol key={index} sizeXs='12' sizeSm='12' sizeMd='6'>
                                                                <IonItem className='ion-margin-start' lines='none'>
                                                                    <IonIcon className='ion-margin-start' color={'success'} icon={checkmarkCircle} size='small' slot='start'></IonIcon> 
                                                                    <IonLabel><p>{vehicle}</p></IonLabel>
                                                                </IonItem>
                                                            </IonCol>)))
                                                        : (<IonCol>
                                                                <IonItem className='ion-margin-start' lines='none'>
                                                                    <IonIcon className='ion-margin-start' color={'warning'} icon={closeCircle} size='small' slot='start'></IonIcon>
                                                                    <IonLabel><p>No Vehicles selected</p></IonLabel>
                                                                </IonItem>
                                                            </IonCol>)                                          
                                                    } 
                                                </IonRow>
                                            </IonCol>
                                        </IonRow>)
                                    }

                                    { routeType == 'ONE-WAY' &&
                                        (<IonRow>
                                            <IonCol size='12'>
                                                <IonItem lines='none'>
                                                    <IonIcon color={'tertiary'} icon={car} slot='start'></IonIcon>
                                                    <IonLabel className='ion-text-wrap'><b>SoloWise Vehicles Parked at the Ending Place</b></IonLabel>
                                                </IonItem>
                                            </IonCol>
                                            <IonCol className='ion-padding-start' size='12'> 
                                                <IonRow>
                                                    {selectedVehicleEndNames.length > 0
                                                        ? (selectedVehicleEndNames.map((vehicle, index) => (
                                                            <IonCol key={index} sizeXs='12' sizeSm='12' sizeMd='6'>
                                                                <IonItem lines='none'>
                                                                    <IonIcon color={'success'} icon={checkmarkCircle} size='small' slot='start'></IonIcon> 
                                                                    <IonLabel><p>{vehicle}</p></IonLabel>
                                                                </IonItem>
                                                            </IonCol>)))
                                                        : (<IonCol>
                                                                <IonItem className='ion-margin-start' lines='none'>
                                                                    <IonIcon className='ion-margin-start' color={'warning'} icon={closeCircle} size='small' slot='start'></IonIcon>
                                                                    <IonLabel><p>No Vehicles selected</p></IonLabel>
                                                                </IonItem>
                                                            </IonCol>)                                           
                                                    } 
                                                </IonRow>
                                            </IonCol>
                                        </IonRow>)
                                    }

                                    </>)
                                }

                                <IonRow>
                                    <IonCol size='12'>
                                        <IonItem lines='none'>
                                            <IonIcon color={'tertiary'} icon={medkitOutline} slot='start'></IonIcon>
                                            <IonLabel><b>Safety / Survival Equipment</b></IonLabel>
                                        </IonItem>
                                    </IonCol>
                                    <IonCol className='ion-padding-start' size='12'> 
                                        <IonRow>
                                            {checkedEquipment.length > 0
                                                ? (checkedEquipment.map((eq, index) => (
                                                    <IonCol key={index} sizeXs='12' sizeSm='6' sizeMd='4'>
                                                        <IonItem className='ion-margin-start' lines='none'>
                                                            <IonIcon className='ion-margin-start' color={'success'} icon={checkmarkCircle} size='small' slot='start'></IonIcon> 
                                                            <IonLabel><p>{eq}</p></IonLabel>
                                                        </IonItem>
                                                    </IonCol>)))
                                                : (<IonCol>
                                                        <IonItem className='ion-margin-start' lines='none'>
                                                            <IonIcon className='ion-margin-start' color={'warning'} icon={closeCircle} size='small' slot='start'></IonIcon>
                                                            <IonLabel><p>No Equipment selected</p></IonLabel>
                                                        </IonItem>
                                                    </IonCol>)                                            
                                            } 
                                        </IonRow>
                                    </IonCol>
                                </IonRow>

                                <IonRow>
                                    <IonCol size='12'>
                                        <IonItem lines='none'>
                                            <IonIcon color={'tertiary'} icon={informationCircleOutline} slot='start'></IonIcon>
                                            <IonLabel><b>Instructions for Your Emergency Contacts</b></IonLabel>
                                        </IonItem>
                                    </IonCol>
                                    <IonCol className='ion-padding-start' size='12'>
                                        <IonRow>
                                            {timer.notes != '' 
                                                ? (<IonCol>
                                                        <IonItem className='ion-margin-start' lines='none'>
                                                            <IonIcon className='ion-margin-start' color={'success'} icon={checkmarkCircle} size='small' slot='start' style={{verticalAlign: 'top'}}></IonIcon>
                                                            <IonLabel><p><IonText><span dangerouslySetInnerHTML={{ __html: nl2br(timer.notes) }} /></IonText></p></IonLabel>
                                                        </IonItem>
                                                    </IonCol>)
                                                : (<IonCol>
                                                        <IonItem className='ion-margin-start' lines='none'>
                                                            <IonIcon className='ion-margin-start' color={'warning'} icon={closeCircle} size='small' slot='start'></IonIcon>
                                                            <IonLabel><p>Not Recorded</p></IonLabel>
                                                        </IonItem>
                                                    </IonCol>)   
                                            }   
                                        </IonRow>                        
                                    </IonCol>
                                </IonRow>

                            </IonGrid>                            
                    </IonCardContent>
                </IonCard>

                <div className='ion-text-center'>
                    {(timer.status == '0' || timer.status == '1') &&
                    <IonButton className='ion-margin' color={'secondary'} fill="outline" onClick={confirmShareSummary}><IonIcon icon={shareOutline} slot='start'></IonIcon> Share Summary</IonButton>
                    }
                    {(timer.status == '0' || timer.status == '1') &&
                    <IonButton className='ion-margin' disabled={!locationPerm} color={'secondary'} fill="outline" onClick={confirmShareMap}><IonIcon icon={mapOutline} slot='start'></IonIcon> Share Live Map</IonButton>
                    }
                    {(timer.status != 4 && !timer.alarm && timer.alarm === 0) &&
                    <IonButton className='ion-margin delete-button-outline' fill="outline" onClick={confirmDeleteTimer}><IonIcon icon={trashOutline} slot='start'></IonIcon> Remove Timer</IonButton>
                    }
                </div>

            </IonContent>
        </IonPage>
    );
};

export default TimerView;
